import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const getCourseById = createAsyncThunk(
  "teacher/course/getById",
  async (courseId) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
  const request = await fetch(
    `${process.env.REACT_APP_VERSEL_API}/api/teacher/getCourseById/${courseId}`,
    {
      method: "GET",
      headers:{
        "Authorization" : `Bearer ${tokenData}`
      }
    }
  )
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => {
      formatError(error);
    });

  return request;
});

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getByIdTeacherCourseSlicer = createSlice({
  name: "getCouses",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(getCourseById.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCourseById.fulfilled, (state, action) => {
        state.loading = false;

      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      }
     else  if (action.payload.message === "fetched successfully") {
        state.data = action.payload;
     
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(getCourseById.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });

  },
});

export default getByIdTeacherCourseSlicer.reducer;

